module.exports = __webpack_public_path__ + "fonts/slick.b7c9e1e.woff";